export const processPowerData = (data, timeFilter) => {
  if (!data || !Array.isArray(data)) return [];

  return data.map(item => {
    const timestamp = new Date(parseInt(timeFilter === 'weekly' ? item.hour_timestamp : item.timestamp));
    const batteryCurrent = parseFloat(item.batterycurrent) / 1024;
    const voltage = parseFloat(item.voltage) / 128;
    const recCurrentO = parseFloat(item.reccurrento) / 1024;
    const recVoltO = parseFloat(item.recvolto) / 128;
    const invCurr = parseFloat(item.invcurr) / 5;
    const invVolt = parseFloat(item.invvolt);
    const chargerStatus = parseInt(item.chargerstatus) & 0x03;

    const bmsPower = Math.abs((batteryCurrent * voltage) / 1000).toFixed(3);
    const rectifierPower = Math.abs((recCurrentO * recVoltO) / 1000).toFixed(3);
    const acInverterPower = Math.abs((invCurr * invVolt) / 1000).toFixed(3);

    let dcInverterPower = 0;
    if (rectifierPower <= 0) {
      dcInverterPower = Math.abs(bmsPower) - acInverterPower;
    } else if (rectifierPower > 0 && chargerStatus === 0 && batteryCurrent >= 0.5) {
      dcInverterPower = (rectifierPower + Math.abs(bmsPower)) - acInverterPower;
    } else if (rectifierPower > 0) {
      const _bmsPower = Math.abs(bmsPower);
      const _dcInverterPower = rectifierPower - (_bmsPower + parseFloat(acInverterPower));
      dcInverterPower = _dcInverterPower <= 0 ? 0 : _dcInverterPower;
    }
    dcInverterPower = Math.abs(dcInverterPower).toFixed(3);

    const displayTime = timeFilter === 'daily' 
      ? timestamp.toLocaleTimeString('en-US', {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        })
      : timestamp.toLocaleDateString('en-US', {
          weekday: timeFilter === 'weekly' ? 'short' : undefined,
          month: 'short',
          day: 'numeric'
        });

    // Keep detailed time in tooltip for weekly view
    const tooltipTime = timeFilter === 'weekly' 
      ? `${timestamp.toLocaleDateString('en-US', {
          weekday: 'short',
          month: 'short',
          day: 'numeric'
        })} ${timestamp.toLocaleTimeString('en-US', {
          hour12: false,
          hour: '2-digit',
          minute: '2-digit'
        })}`
      : timestamp.toLocaleString('en-US', {
          weekday: 'short',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });

    return {
      ...item,
      timestamp: timestamp.getTime(),
      displayTime,
      tooltipTime,
      bmsPower,
      rectifierPower,
      acInverterPower,
      dcInverterPower
    };
  });
};
